
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function ExecutiveCTA() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section id="consultation" className="py-28 md:py-40 bg-white">
      <div ref={ref} className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-[#D4AF37] mb-6">
            Get Started
          </p>
          <h2 className="text-4xl md:text-6xl font-serif text-[#1d1d1f] leading-[1.1] mb-6">
            Let&#39;s Architect Your
            <br />
            <span className="text-[#86868b]">Growth Infrastructure.</span>
          </h2>
        </div>

        <div className={`transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-base font-light text-[#86868b] max-w-xl mx-auto leading-relaxed mb-12">
            VAZ Global Capital works with operators ready for structured scale — not experimental automation.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#contact"
              className="bg-[#1d1d1f] text-white px-8 py-3.5 rounded-full text-sm font-semibold hover:bg-[#333] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Schedule Executive Consultation
            </a>
            <a
              href="#download"
              className="border border-[#d2d2d7] text-[#1d1d1f] px-8 py-3.5 rounded-full text-sm font-medium hover:border-[#86868b] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Download Overview
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
